import Swiper from 'swiper';
import {Navigation, Pagination} from 'swiper/modules';
import {getCssVariable} from "../../../utilities/Helper";
import {ContainerEngine} from "../../../utilities/ContainerEngine";
import {onWindowResize} from "../../../utilities/Hooks";

function computeContainerOffsetX() {
    return ContainerEngine.find('xl').offsetX + parseInt(getCssVariable('--container-padding'));
}

function updateHeadingElementOffsetX(element) {
    element.style.marginLeft = `${computeContainerOffsetX()}px`;
}

function getNewSwiperInstance() {
    return new Swiper('#carouselStories', {
        modules: [Navigation, Pagination],
        pagination: {
            el: ".stories-pagination",
            clickable: true,
        },
        speed: 400,
        freeMode: {
            enabled: false,
            sticky: false,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        slidesPerView: 'auto',
        slidesOffsetBefore: computeContainerOffsetX,
        spaceBetween: 20,
    });
}

export default function setupCarouselStories() {
    if (document.querySelector('.section-stories') === null) return;
    const swiper = getNewSwiperInstance();
    const storiesHeadingElement = document.querySelector('.section-stories__header');
    updateHeadingElementOffsetX(storiesHeadingElement);

    onWindowResize(() => {
        swiper.params.slidesOffsetBefore = computeContainerOffsetX();
        updateHeadingElementOffsetX(storiesHeadingElement);
    })
}
